import { useEffect } from "react";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { StateMachineProvider } from "little-state-machine";
import { FormContainer } from "@/components/form/form-container";
import "/node_modules/@awesome.me/kit-89c13ac8b2/icons/js/all.js";

config.autoAddCss = false;

interface IAppProps {
  formId: string;
  themeId?: string | null;
  servicePartnerId?: string | null;
  servicePartnerCollectionId?: string | null;
  clientId?: string;
  clientSecret?: string;
}

function App(props: IAppProps) {
  useEffect(() => {
    // Set the client ID and secret in local storage
    if (props.clientId && props.clientSecret) {
      localStorage.removeItem("accessToken");
      localStorage.setItem("clientId", props.clientId);
      localStorage.setItem("clientSecret", props.clientSecret);
    }
  }, [props.clientId, props.clientSecret]);

  return (
    <div className="App">
      <StateMachineProvider>
        <div className="w-full">
          <FormContainer
            servicePartnerId={props.servicePartnerId}
            servicePartnerCollectionId={props.servicePartnerCollectionId}
            formId={props.formId}
            themeId={props.themeId}
          />
        </div>
      </StateMachineProvider>
    </div>
  );
}

export default App;
